import React, { ReactElement } from 'react';
import { observer } from 'src/utils/mobx-react';
import { GameContentWrapper, GameIframe, IframeContainer, ModalWrapper, HeaderWrapper } from './XtremePushModal.style';
import { HeaderLogo } from 'src/domains/casino/webview/CasinoGames/game-modal/modal-header/header-logo/HeaderLogo';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    ButtonsWrapper,
    CloseGameIcon,
    InFullScreenIcon,
    OutFullScreenOutIcon,
    ResizeButton,
} from 'src/domains/casino/webview/CasinoGames/game-modal/modal-header/ModalHeader.style';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

export const XtremePushModal = observer('XtremePushModal', (): ReactElement => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { xtremePushState } = appLayoutsState;
    return (
        <ModalWrapper
            ref={xtremePushState.setRef}
            isDepositOpened={xtremePushState.isDepositOpened}
        >
            <HeaderWrapper data-test='game-modal-header'>
                <HeaderLogo />
                <ButtonsWrapper>
                    <Button
                        onClick={xtremePushState.redirectToDepositPage}
                        size='medium'
                        dataTest='game-modal-deposit-button'
                    >
                        <I18n
                            langKey='casino.games.launch.deposit'
                            defaultText='Deposit'
                        />
                    </Button>
                    <ResizeButton
                        onClick={xtremePushState.toggleFullScreen}
                        className={xtremePushState.isFullScreen ? 'fullscreen' : ''}
                    >
                        {xtremePushState.isFullScreen ? <InFullScreenIcon /> : <OutFullScreenOutIcon />}
                    </ResizeButton>
                    <CloseGameIcon onClick={xtremePushState.closeGame} />
                </ButtonsWrapper>
            </HeaderWrapper>
            <GameContentWrapper data-test='xtreme-push-modal-success'>
                <IframeContainer>
                    <GameIframe
                        title='xtreme-push-modal'
                        src={xtremePushState.url}
                        dataTest='xtreme-push-iframe'
                    />
                </IframeContainer>
            </GameContentWrapper>
        </ModalWrapper>
    );
});
